<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light m-0">
    <!-- Alert message -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- Title-->
    <header-component :headerTitle="headerText" />

    <!-- Update  popup  -->
    <v-row justify="center">
      <v-dialog v-model="UpdatePopup" persistent max-width="860px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Update Confirmation</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="updatePendingConfirmationCancel">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-form>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-tabs v-model="tab_index">
                    <v-tab ripple :href="'#'" @click="update_current_Tab(tab)" style="text-transform:none!important;text-decoration: none;" v-for="(tab, index) in updateConfirmTab" :key="`${tab + index}`">
                      <span v-if="index == 0">{{ tab }} ({{ selected.length }})</span>
                      <span v-else>{{ tab }}</span>
                    </v-tab>
                  </v-tabs>
                </v-row>
                <div v-if="currentUdateTab == 'Selected Items'">
                  <v-layout column>
                    <v-col md6 style="overflow: auto">
                      <v-list-item-content class="pl-2 pr-2">
                        <v-data-table hover
                          density="compact"
                          :headers="updateHeaders"
                          :items="selected" 
                          style="max-height: 300px; overflow: scroll;" 
                          disable-pagination 
                          :hide-default-footer="true"
                          class="elevation-1">
                          <template #[`item.tag_number`]="{ item }">
                            <a @click="itemDetailpopup(item)" style="color: #1976d2;">
                              <u> {{ item.tag_number }}</u>
                            </a>
                          </template>
                          <template #[`item.action`]="{ item }">
                            <img @click="deleteEvent(item)" src="@/assets/images/delete_red.png" title="Delete item" />
                          </template>
                          <template #bottom></template>
                        </v-data-table>
                      </v-list-item-content>
                    </v-col>
                  </v-layout>
                </div>
                <div v-if="currentUdateTab == 'Update'">
                  <v-row class="mt-4">
                    <v-col cols="12" sm="5" md="6">
                      <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
                        :return-value="rtv_return_date" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ props }">
                          <v-text-field variant="outlined" hide-details v-model="formattedReturnDate" label="Return Date" prepend-inner-icon="mdi-calendar" color="primary" readonly v-bind="props"></v-text-field>
                        </template>
                        <v-card class="m-0 overflow-hidden calendar-layout" width="300">
                          <v-date-picker :min="new Date().toISOString().substr(0, 10)" v-model="isRtvReturnDate" hide-header color="primary" min-width="200" max-width="300" scrollable>
                          </v-date-picker>
                          <v-card-action class="d-flex justify-end pb-3">
                            <v-spacer></v-spacer>
                            <v-btn variant="text" color="primary" @click="menu = false">Cancel</v-btn>
                            <v-btn variant="text" color="primary" @click="handleSaveDate('menu', 'rtv_return_date', 'isRtvReturnDate')">OK</v-btn>
                          </v-card-action>
                        </v-card>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="5" md="6">
                      <v-autocomplete color="primary" v-model="returnMethod" variant="outlined" :items="rtv_return_method_list" item-title="name" item-value="value" label="Return Method"> </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="5" md="6">
                      <v-autocomplete color="primary" v-model="returnDocType" variant="outlined" :items="rtv_return_doc_type" item-title="name" item-value="value" :label="organization_name ? 'Invoice or Delivery Challan' : 'Return Document Type'"> </v-autocomplete>
                    </v-col>
                  </v-row>
                </div>
              </v-container>
            </v-card-text>

          </v-form>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" color="primary" class="cancel-color mb-3" @click="updatePendingConfirmationCancel">Cancel</v-btn>
            <v-btn :color="!isFormValid || this.number > 0 ? '' : 'primary'" variant="flat" class="mb-3" :disabled="!isFormValid || this.number > 0" @click="updatePendingConfirmationSubmit">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog content-class="filter-repair" v-model="filterPopup" persistent max-width="1224px">
        <v-card class="m-0 filter_ui">
          <v-card-actions>
            <v-row>
              <v-col v-if="isPendingConfirmationTab">
                <v-text-field prepend-inner-icon="mdi-magnify" color="primary" v-model="rtv_article_id_search" label="Article Id" class="m-0" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
              </v-col>
              <v-col v-if="isPendingConfirmationTab">
                <v-combobox v-on:keyup.enter="loadData(active_tab)" prepend-inner-icon="mdi-magnify" v-model="rtv_brand_search" :items="brandList" item-title="brandList" item-value="brandList" label="Brand" multiple variant="outlined" class="m-0" @input="handleAutocompleteInput('rtv_brand_search')" ref="brandAutocomplete"> </v-combobox>
                <!-- <v-autocomplete  prepend-inner-icon="mdi-magnify" v-model="rtv_brand_search" variant="outlined" color="primary" :items="brandList" item-title="brandList" item-value="brandList" label="Brand" class="m-0" multiple @update:modelValue="handleAutocompleteInput('rtv_brand_search')" ref="brandAutocomplete"> </v-autocomplete> -->
              </v-col>
              <v-col v-if="isPendingConfirmationTab">
                <v-combobox v-on:keyup.enter="loadData(active_tab)" prepend-inner-icon="mdi-magnify" v-model="rtv_vendor_search" :items="vendorList" item-title="vendor_name" item-value="id" label="Vendor" multiple variant="outlined" class="m-0" @input="handleAutocompleteInput('rtv_vendor_search')" ref="vendorAutocomplete"> </v-combobox>
                <!-- <v-autocomplete v-on:keyup.enter="loadData(active_tab)" prepend-inner-icon="mdi-magnify" v-model="rtv_vendor_search" variant="outlined" color="primary" :items="vendorList" item-title="vendor_name" item-value="id" label="Vendor" class="m-0" multiple @update:modelValue="handleAutocompleteInput('rtv_vendor_search')" ref="vendorAutocomplete"> </v-autocomplete> -->
              </v-col>
              <v-col v-if="isPendingConfirmationTab">
                <v-text-field prepend-inner-icon="mdi-magnify" v-model="rtv_approval_code_search" label="Approval Code" class="m-0" variant="outlined" color="primary" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
              </v-col>
              <v-col v-if="isPendingConfirmationTab">
                <v-autocomplete  color="primary" style="max-width: 290px !important;"
                  v-model="putaway_filter" variant="outlined" :items="puttawayList"
                   label="Putaway Status" class="ma-0">
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn size="small" variant="outlined" color="normal" class="text-none" @click="closeFilterpopup">Cancel</v-btn>
            <v-btn size="small" variant="flat" color="primary" class="text-none" @click="applyFilterFunc">Apply Filter(s)</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Table-data Detail Popup for Pending Confirmation -->
    <v-row justify="center">
      <v-dialog v-model="dataDetailPendingConfirmationPopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Tag ID: {{ tag_number }}</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="dataDetailPendingConfirmationPopup = !dataDetailPendingConfirmationPopup">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
            <v-container>
              <div>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Article Id</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.sku_code ? item_details.sku_code : 'N/A' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Article Description</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.item_description ? item_details.item_description : 'N/A' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Brand</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.brand ? item_details.brand : 'N/A' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Vendor</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.vendor ? item_details.vendor : 'N/A' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Approval Code</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.approval_code ? item_details.approval_code : 'N/A' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Status</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.confirmation_status ? item_details.confirmation_status : 'N/A' }}
                  </v-col>
                </v-row>
                <v-row v-if="active_tab === 'Pending ORRD'">
                  <v-col cols="6">
                    <span style="font-weight: 500;">ORRD Request ID</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.orrd_request_id ? item_details.orrd_request_id : 'N/A' }}
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Table-data Detail Popup for Dispatch -->
    <v-row justify="center">
      <v-dialog v-model="dataDetailDispatchPopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Tag ID: {{ tag_number }}</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="dataDetailDispatchPopup = !dataDetailDispatchPopup">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
            <v-container>
              <div>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Article Id</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.article_id ? item_details.article_id : 'N/A' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Article Description</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.item_description ? item_details.item_description : 'N/A' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Brand</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.brand ? item_details.brand : 'N/A' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Vendor</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.vendor ? item_details.vendor : 'N/A' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Return Order No</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.order_number ? item_details.order_number : 'N/A' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Challan/Invoice No.</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.invoice_number ? item_details.invoice_number : 'N/A' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Status</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.status ? item_details.status : 'N/A' }}
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <!--Approve Ok confirm popup -->
    <v-row justify="center">
      <v-dialog v-model="okapproveconfirmpopup" persistent max-width="424px">
        <v-card class="v-card-100 pa-2">
          <v-card-title>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text class="text-center">
            <span> {{ message }} </span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="flat" color="primary" class="mb-3 text-none" @click="afterClickOkLoadData">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!--- confirmation dialog -->
    <v-row justify="center">
      <v-dialog v-model="toBeDisposition" persistent max-width="424px">
        <v-card class="v-card-100 pa-2">
          <v-card-title class="d-flex" style="padding: 0px 0px 32px;">
            <v-spacer></v-spacer>
            <v-btn icon @click="toBeDisposition = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span> Are you sure want to move this item to {{ dispos_action.original_code }} ? </span>
          </v-card-text>
          <v-card-actions center class="mt-2">
            <v-spacer></v-spacer>
            <v-btn variant="outlined" color="primary" class="cancel-color mb-3" @click="toBeDisposition = false">Cancel</v-btn>   
            <v-btn variant="flat" color="primary" class="mb-3" @click="setChangeDisposition()">Confirm</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Download Popup Component -->
    <DownloadPopup 
      ref="downloadPopup"
      v-model:visible="downloadDialog" 
      :api-endpoint="computedApiEndpoint"
      :payload="computedPayload"
      @show-alert="handleShowAlert"
      @success="handleSuccess"
    />

    <!-- Header -->
    <v-card class="v-card-100 mt-6">
      <v-tabs color="primary" v-model="main_selected_tab">
        <v-tab ripple @click="loadData(tab, 'tab_clicked')" style="text-transform:none!important;text-decoration: none;" class="tab-color" v-for="(tab, index) in tabs" :key="index">
          {{ tab }}
        </v-tab>
      </v-tabs>
    </v-card>

    <!-- search, filter, Action buttons -->
    <v-card-title style="padding-left: 28px; padding-bottom: 0px; padding-top: 0px;" class="action-style">
    <v-row class="me-3 my-2">
      <!-- Search fields -->
          <v-combobox class="text-left ma-4" v-model="select_field" item-title="name" item-value="id" :items="select_field_items" label="Select Field" variant="outlined" style="max-width: 158px; max-height: 52px;"> </v-combobox>
          <v-text-field color="primary" prepend-inner-icon="mdi-magnify" v-model="search_tag" v-no-edge-space class="m-3 ml-1" :disabled="!select_field" label="Search" style="max-width: 300px; max-height: 52px;" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
          <v-spacer></v-spacer>

      <!-- Actions buttons -->
      <v-card-actions style="min-height: 52px;">
        <v-btn class="mr-2 text-none" size="x-large" variant="flat" :disabled="this.selected.length == 0" v-if="isPendingConfirmationTab && organization_name !== 'Voltas' && !$isRelianceClient() && isActionAllowed(role)" color="primary" @click="updatedialog">Update Confirmation</v-btn>
        <v-btn class="mr-2 text-none" size="x-large" variant="flat" v-if="isPendingConfirmationTab && isActionAllowed(role)" color="primary" @click="redirect_to_upload">Upload</v-btn>
        <!-- <v-btn class="mr-2 text-none" size="x-large" variant="flat" v-if="active_tab == 'Pending Confirmation' && isActionAllowed(role)" color="primary"  @click="downloadConfiramtion">{{organization_name === 'Voltas' || $isRelianceClient()? 'Update Confirmation' : 'Download'}}</v-btn> -->
        <v-btn class="mr-2 text-none" size="x-large" variant="flat" :disabled="table_data.length === 0" v-if="isActionAllowed(role) && isPendingConfirmationTab" color="primary" @click="downloadSelected()">Download</v-btn>
      </v-card-actions>

      <!---  Change disposition -->
      <v-menu
        v-if="active_tab === ''"
        :close-on-content-click="false"
        :offset="[0, 10]"
      >
        <template #activator="{ props }">
          <v-btn
            color="primary"
            size="x-large"
            v-bind="props"
            class="mr-4 text-none"
            style="margin-top: 16px;"
            :disabled="selected.length === 0"
           >
            Change Disposition
            <v-icon>
              mdi-menu-down
            </v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in change_disposition_list"
            :key="index"
            @click="changeDisposition(item)"
          >
            <v-list-item-title>{{ item.original_code }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      
      <!-- Filter -->
      <v-expansion-panels v-if="isPendingConfirmationTab" class="custom-control_outlined m-0 pt-4" ref="filterPopupRef"
        readonly style="max-width: 300px; margin-bottom: 18px; height: 52px;">
        <v-expansion-panel variant="outlined" @click="filterListOfButtons" style="height: 52px;">
          <v-expansion-panel-title>Filter
          </v-expansion-panel-title>
        </v-expansion-panel>
      </v-expansion-panels>
      </v-row>
    </v-card-title>

    <!-- Data Table -->
    <v-layout column>
      <v-col cols="12" class="px-0" style="overflow: auto">
        <v-data-table hover 
          density="compact"
          :search="search"
          v-model="selected"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          :items-per-page="pageSize"
          :loading="loading"
          fixed-header
          height="100%"
          loading-text="Loading Data... Please wait" class="elevation-1"
          return-object
          >
          <template #[`header.disposition_age`]="{ column }">
            <span>{{ column.title }}
              <AgeingTooltip />
            </span>
          </template>
          <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers" :key="header.key">
            <span v-if="header.key == 'tag_number'">
                <a href="#" @click.prevent="itemDetailpopup(item)" style="color: #1976d2 !important; cursor: pointer !important;"><u> {{ item.tag_number }}</u></a>
            </span>
            <span v-else-if="header.key !== 'tag_number' && item[header.key]">
              <span v-tooltip="item[header.key]">
                {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
              </span>
            </span>
            <span v-else>-</span>
          </template>
          <!-- <template #[`item.tag_number`]="{ item }">
            <a @click="itemDetailpopup(item)" style="color: #1976d2;">
              <u> {{ item.tag_number }}</u>
            </a>
          </template> -->
          <!-- <template #[`item.brand`]="{ item }">
            <span>{{ item.brand && item.brand != "N/A" ? item.brand : '-' }}</span>
          </template>
          <template #[`item.vendor`]="{ item }">
            <span>{{ item.vendor && item.vendor != "N/A" ? item.vendor : '-' }}</span>
          </template>
          <template #[`item.approval_code`]="{ item }">
            <span>{{ item.approval_code && item.approval_code != "N/A" ? item.approval_code : '-' }}</span>
          </template>
          <template #[`item.date_for_dispatch`]="{ item }">
            <span>{{ item.date_for_dispatch && item.date_for_dispatch != "N/A" ? item.date_for_dispatch : '-' }}</span>
          </template>
          <template #[`item.invoice_number`]="{ item }">
            <span>{{ item.invoice_number && item.invoice_number != "N/A" ? item.invoice_number : '-' }}</span>
          </template>
          <template #[`item.sub_location_name`]="{ item }">
            <span>{{ item.sub_location_name ? item.sub_location_name : '-' }}</span>
          </template> -->
          <template #bottom></template>
        </v-data-table>
      </v-col>
    </v-layout>

    <!-- pagination display -->
            <div>
                <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-1 mb-0"
                />
            </div>
  </v-card>
</template>

<script>
  import HeaderComponent from '../../../../commoncomponents/HeaderComponent.vue';
  import DownloadPopup from '../../../../commoncomponents/DownloadPopup.vue';
  import { mixinHelper } from "@//mixins/mixin-helper.js";
   import { moduleAccessFunc,module_that_allowed,signout,isOnlyViewAction } from '@/backend/axios/moduleAccess';
   import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
  // import { moduleAccessFunc,module_that_allowed,signout } from '@/backend/axios/moduleAccess';
  export default {
    mixins: [mixinHelper],
    components: {
      HeaderComponent,
      DownloadPopup
    },

    data() {
      return {
        headerText: "RTV",
        tabs: [
          "Pending Confirmation",
          "Dispatch",
          "Pending For Approval",
        ],
        search_tag: '',
        table_data: [],
        original_table_data: [],
        page: 1,
        totalPages: 1,
        totalCount: '',
        pageSize: defaultPageSize,
        pageSizes: defaultPageSizes,
        active_tab: "Pending Confirmation",
        selected: [],
        search: '',
        filterPopup: false,
        rtv_article_id_search: '',
        main_selected_tab : 0,
        rtv_brand_search: [],
        rtv_vendor_search: [],
        rtv_approval_code_search: '',
        UpdatePopup: false,
        vendorList: '',
        rtv_id: [],
        rtv_return_date: '',
        isRtvReturnDate: new Date(),
        returnMethod: null,
        returnDocType: null,
        rtv_return_method_list: [
          { name: "Dispatch", value: "Dispatch" },
          { name: "Handover", value: "Handover" }
        ],
        rtv_return_doc_type: [
          { name: "Invoice", value: "Invoice" },
          { name: "Delivery Challan", value: "Delivery Challan" }
        ],
        okapproveconfirmpopup: false,
        message: '',
        tag_number: '',
        dataDetailPendingConfirmationPopup: false,
        dataDetailDispatchPopup: false,
        item_details: '',
        brandList: [],
        alert_type: 'info',
        alert_message: '',
        alert: false,
        menu: false,
        number: 0,
        headers: [],
        updateConfirmTab: ["Selected Items", "Update"],
        currentUdateTab: '',
        organization_name:'',
        tab_index: 1,
        updateHeaders: [
          { title: "Tag ID", align: "start", sortable: false, key: "tag_number", minWidth:"200px"  },
          { title: "Article ID", key: "sku_code", minWidth:"200px" },
          { title: "Article Description", key: "item_description", minWidth:"200px"  },
          { title: "Date", key: "date_for_dispatch", minWidth:"200px"  },
          { title: 'Delete', key: 'action', minWidth:"200px" }
        ],
        change_disposition_list: [],
        dispos_action: '',
        toBeDisposition: false,
        role: '',
        select_field_items: [
        {
          "name":"Tag ID",
          "id": "tag_number"
        },
        {
          "name":"Serial Number",
          "id": "serial_number"
        },
        {
          "name":"IRD Number",
          "id": "ird_number"
        },
        {
          "name":"IRRD Number",
          "id": "irrd_number"
        }
        ],
        select_field:null,
        putaway_filter:null,
        puttawayList:["Pending","Completed"],
        downloadDialog: false,
        
        }
    },

    async created() {
      this.role = this.$store.state.currentUser.roles[0]
      if(this.role in module_that_allowed && moduleAccessFunc(this.role,'RTV')){
        signout()
        return;
      }
      this.organization_name = this.$store.state.organization_name
      this.currentUser = this.$store.state.currentUser;
      const tab = this.$store.state.active_tab
      if(tab == 'Dispatch'){
        this.main_selected_tab = 2
        this.loadData('Dispatch');
      } else if(tab == 'Pending ORRD'){
        this.main_selected_tab = 1
        this.loadData('Pending ORRD');
      } else {
        this.main_selected_tab = 0
        this.loadData('Pending Confirmation');
      }
      this.fetchFilterVendorList();
      this.fetchFilterBrandList();
    },

    computed: {
      isFormValid() {
        return (
          this.rtv_return_date !== '' &&
          this.returnMethod !== '' &&
          this.returnDocType !== ''
        );
      },
      formattedReturnDate() {
        if (this.rtv_return_date) {
          const date = new Date(this.rtv_return_date);
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        }
        return '';
      },
      computedApiEndpoint() {
        if (this.isPendingConfirmationTab) {
          return "/api/v2/warehouse/vendor_return/pending_confirmation/download_rtv_file";
        } else if (this.active_tab === 'Dispatch') {
          return "/api/v2/warehouse/vendor_return/dispatch";
        } else {
          return "/api/v2/warehouse/vendor_return/pending_confirmation";
        }
      },
      computedPayload() {
        const ids = this.selected.map(x => (x.id));
        if (this.isPendingConfirmationTab) {
          return { ids };
        } else if (this.active_tab === 'Dispatch') {
          return {
            ids,
            is_download: true,
          };
        } else if (this.active_tab === 'Pending For Approval') {
          return {
            ids,
            is_download: true,
            status: "pending_approval"
          };
        } else {
          return {
            ids,
            is_download: true,
          };
        }
      },
      isPendingConfirmationTab() {
        return this.active_tab === 'Pending Confirmation' || this.active_tab === 'Pending ORRD';
      }
    },

    watch: {
      selected(newVal) {
        if (this.isPendingConfirmationTab) {
          const putawayInward = newVal.filter(insurances => insurances.is_putaway_inwarded === false)
          const isUnderPhysicalInspection = newVal.filter((insurances) => insurances.is_under_physical_inspection === true);
          if (putawayInward.length > 0) {            
            this.$nextTick(() => {
              this.showAlert("warning", "Please complete Putaway Process");
              this.selected = [];
            });
          }else if(isUnderPhysicalInspection.length > 0){
            this.$nextTick(() => {
              this.showAlert("warning", "Action on item blocked as it is under cycle count process");
              this.selected = [];
            });
          }
        }
      },
      rtv_brand_search(newValue) {
        if (newValue && newValue.length > 0) {
          this.$nextTick(() => {
            this.$refs.brandAutocomplete.internalSearch = '';
          });
        }
      },
      rtv_vendor_search(newValue) {
        if (newValue && newValue.length > 0) {
          this.$nextTick(() => {
            this.$refs.vendorAutocomplete.internalSearch = '';
          });
        }
      }
    },
    methods: {
      isActionAllowed(){
        return !isOnlyViewAction(this.role, 'RTV')
      },
      openPopup() {
        this.downloadDialog = true;
      },
      handleAutocompleteInput(fieldName) {
        if(fieldName == 'rtv_brand_search'){
          this.$refs.brandAutocomplete.internalSearch = '';
        }
        else if(fieldName == 'rtv_vendor_search'){
          this.$refs.vendorAutocomplete.internalSearch = '';
        }
      },
      getRequestParams(page, pageSize) {
        let params = {};


        if (page) {
          params["page"] = page;
        }

        if (pageSize) {
          params["size"] = pageSize;
        }

        return params;
      },

      //  show Alert messages
      showAlert(alert_type, alert_message) {
        this.alert = true;
        this.alert_type = alert_type;
        this.alert_message = alert_message;
        this.alertTimeOut();
      },
      alertTimeOut() {
        setTimeout(() => {
          this.alert = false;
        }, 3000);
      },


      loadData(tab, tab_action) {
        if (tab_action) {
          this.search_tag = '';
          this.select_field = null;
        }
        this.loading = true;
        this.selected = []
        this.active_tab = tab
        this.table_data = []
        this.page = 1
        this.totalPages = 1
        this.$store.commit('setActiveTab',{
          'active_tab' : tab
        })
        this.select_field_items = [
              {
                "name":"Tag ID",
                "id": "tag_number"
              },
              {
                "name":"Serial Number",
                "id": "serial_number"
              },
              {
                "name":"IRD Number",
                "id": "ird_number"
              },
              {
                "name":"IRRD Number",
                "id": "irrd_number"
              }
              ];
        if (tab == "Pending Confirmation") {
          (this.headers = [
            { title: "Tag ID", align: "start", sortable: false, key: "tag_number", minWidth:"200px"  },
            { title: "Article ID", key: "sku_code", sortable: true, minWidth:"200px" },
            { title: "Article Description", key: "item_description", sortable: true, minWidth:"200px" },
            { title: "Brand", key: "brand", sortable: true, minWidth:"200px"  },
            { title: "Vendor", key: "vendor", sortable: true, minWidth:"200px"  },
            { title: "Approval Code", key: "approval_code", sortable: true, minWidth:"200px" },
            { title: "Status", key: "confirmation_status", sortable: true, minWidth:"200px"  },
            { title: "Date for Dispatch", key: "date_for_dispatch", sortable: true, minWidth:"200px"  },
            { title: "Ageing", key:"disposition_age"},
            { title: "Sub-Location", key:"sub_location_name"},
            { title: "IRRD Number", key: "irrd"},
            { title: "IRD Number", key:"ird"},
            { title: "Serial Number ", key: "serial_number" },
          ]);

          this.fetchPendingConfirmation();
          if(this.$isRelianceClient()){
            this.fetchChangeDisposition();
          }
        }
        if (tab == "Pending ORRD") {
          (this.headers = [
            { title: "Tag ID", align: "start", sortable: false, key: "tag_number", minWidth:"200px"  },
            { title: "Article ID", key: "sku_code", sortable: true, minWidth:"200px" },
            { title: "Article Description", key: "item_description", sortable: true, minWidth:"200px" },
            { title: "Brand", key: "brand", sortable: true, minWidth:"200px"  },
            { title: "Vendor", key: "vendor", sortable: true, minWidth:"200px"  },
            { title: "Approval Code", key: "approval_code", sortable: true, minWidth:"200px" },
            { title: "Status", key: "confirmation_status", sortable: true, minWidth:"200px"  },
            { title: "Date for Dispatch", key: "date_for_dispatch", sortable: true, minWidth:"200px"  },
            { title: "Ageing", key:"disposition_age"},
            { title: "Sub-Location", key:"sub_location_name"},
            { title: "IRRD Number", key: "irrd"},
            { title: "IRD Number", key:"ird"},
            { title: "Serial Number ", key: "serial_number" },
            { title: "ORRD Request ID", key: "orrd_request_id" },
          ]);

          this.fetchPendingOrrd();
          if(this.$isRelianceClient()){
            this.fetchChangeDisposition();
          }
        }
        if (tab == "Dispatch") {
          (this.headers = [
            { title: "Tag ID", align: "start", sortable: false, key: "tag_number", minWidth:"200px"  },
            { title: "Brand", key: "brand", sortable: true, minWidth:"200px"  },
            { title: "Vendor", key: "vendor", sortable: true, minWidth:"200px"  },
            { title: "Return Order No", key: "order_number", sortable: true, minWidth:"200px"  },
            { title: "Challan/Invoice No", key: "invoice_number", sortable: true, minWidth:"200px"  },
            { title: "Ageing", key:"disposition_age"},
            { title: "Status", key: "status", sortable: true , minWidth:"200px" },
            { title: "IRRD Number", key: "irrd"},
            { title: "IRD Number", key:"ird"},
            { title: "Serial Number ", key: "serial_number" },
          ]);

          this.fetchDispatch();
        }
        if ((tab == 'Pending For Approval')) {
          this.headers = [
                    { title: "Location", key: "location"},
                    { title: "IRD", key: "ird" },
                    { title: "Tag ID", key: "tag_number" },
                    { title: "Article ID", key: "article_id" },
                    { title: "Article Description", key: "article_description"},
                    { title: "Lot ID", key: "lot_id" },
                    { title: "Publish ID", key: "publish_id"},
                    { title: "Recovery Benchmark Price", key: "recovery_benchmark_price" },
                    { title: "Serial No.1", key: "serial_number" },
                    { title: "Serial No.2", key: "serial_number2"},
                    { title: "Approval Type", key: "approval_rule_type"},
                    { title: "Pending At", key: "next_approver_details"}
                ];
          this.select_field_items = [
             {
                "name":"Tag ID",
                "id": "tag_number"
              },
              {
                "name":"IRD",
                "id": "ird_number"
              },
              {
                "name":"Lot ID",
                "id": "lot_id"
              },
              {
                "name":"Publish ID",
                "id": "publish_id"
              },
              {
                "name":"Pending at",
                "id": "pending_at"
              }];

          this.fetchPendingForApproval();
          }
      },


      // fetch the data from the API to load data to the table
      fetchPendingConfirmation() {
        const params = {
          page: this.page,
          per_page: this.pageSize
        };
        if(this.search_tag){
          params[this.select_field.id] = this.search_tag.trim()
        }
        this.$httpSecured
          .post("/api/v2/warehouse/vendor_return/pending_confirmation", params)
          .then(response => {
            if (response.data) {
              this.table_data = response.data.vendor_returns
              this.totalPages = response.data.meta.total_pages
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });

      },

      // fetch the Pending ORRD data from the API to load data to the table
      fetchPendingOrrd() {
        const params = {
          page: this.page,
          per_page: this.pageSize,
	  status: "pending_orrd"
        };
        if(this.search_tag){
          params[this.select_field.id] = this.search_tag.trim()
        }
        this.$httpSecured
          .post("/api/v2/warehouse/vendor_return/pending_orrd", params)
          .then(response => {
            if (response.data) {
              this.table_data = response.data.vendor_returns
              this.totalPages = response.data.meta.total_pages
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },

      fetchDispatch() {
        const params = {
          page: this.page,
          per_page: this.pageSize
        };
        if(this.search_tag){
          params[this.select_field.id] = this.search_tag.trim()
        }
        this.$httpSecured
          .post("/api/v2/warehouse/vendor_return/dispatch", params)
          .then(response => {
            if (response.data) {
              this.table_data = response.data.warehouse_order_items
              this.totalPages = response.data.meta.total_pages
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });

      },
      fetchPendingForApproval() {
        const params = {
          page: this.page,
          per_page: this.pageSize,
          status:"pending_approval"
        };
        if(this.search_tag){
          params[this.select_field.id] = this.search_tag.trim()
        }
        this.$httpSecured
          .post("/api/v2/warehouse/vendor_return/pending_confirmation", params)
          .then(response => {
            if (response.data) {
              this.table_data = response.data.vendor_returns
              this.totalPages = response.data.meta.total_pages
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      //  fetch the vendor list in the filter drop-down
      fetchFilterVendorList() {
        this.$httpSecured
          .get("/api/v2/warehouse/vendor_return/pending_confirmation/vendor_list")
          .then(response => {
            if (response.data) {
              this.vendorList = response.data.vendor_list
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
          });
      },

      fetchChangeDisposition(){
        this.$httpSecured
        .get("/api/v2/warehouse/vendor_return/pending_confirmation/get_dispositions")
        .then(response => {
          if (response.data) {
            this.change_disposition_list = response.data.dispositions
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
        });
      },
      changeDisposition(item){
        this.toBeDisposition = true;
        this.dispos_action = item;
      },
      setChangeDisposition(item) {
        const ItemId = this.selected.map(item => item.id)
        const dispositionId = this.dispos_action.id
        const requestData = {
          vendor_return: {
            ids: ItemId
          },
          disposition_id: dispositionId
        };
        this.$httpSecured
          .post("/api/v2/warehouse/vendor_return/pending_confirmation/set_disposition", requestData)
          .then(response => {
            if (response.data) {
              this.toBeDisposition = false;
              this.okapproveconfirmpopup = true;
              this.message = response.data.message;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      //  fetch the Brand list in the filter drop-down
      fetchFilterBrandList() {
        this.$httpSecured
          .get("/api/v2/warehouse/vendor_return/pending_confirmation/brand_list")
          .then(response => {
            if (response.data) {
              this.brandList = response.data.brand_list
            } else {
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
          });
      },


      applyFilterFunc() {
        const filter = {};
          if (this.rtv_article_id_search) {
            filter.inventory_id = this.rtv_article_id_search;
          }
          if (this.search_tag) {
            filter.tag_id = this.search_tag;
          }
          if (this.rtv_brand_search && this.rtv_brand_search.length > 0) {
            filter.brands = this.rtv_brand_search;
          }
          if (this.rtv_vendor_search && this.rtv_vendor_search.length > 0) {
            filter.vendors = this.rtv_vendor_search;
          }
          if (this.rtv_approval_code_search) {
            filter.approval_code = this.rtv_approval_code_search;
          }
          

          const payload = {
            "page": this.page,
            "per_page": this.pageSize,
            filter: filter           
          };
          if (this.putaway_filter) {
            payload.putaway = this.putaway_filter;
          }
        
        this.$httpSecured
          .post('/api/v2/warehouse/vendor_return/pending_confirmation', payload)
          .then(response => {
            if (response.data) {
              this.table_data = response.data.vendor_returns
              this.totalPages = response.data.meta.total_pages
              this.totalCount = response.data.meta.total_count
              this.filterPopup = false;
              this.rtv_article_id_search = '';
              this.rtv_approval_code_search = '';
              this.rtv_brand_search = [];
              this.rtv_vendor_search = [];
              this.putaway_filter = null;
              this.search_tag = '';
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },

      closeFilterpopup() {
        this.filterPopup = false;
        this.rtv_article_id_search = '';
        this.rtv_brand_search = [];
        this.rtv_vendor_search = [];
        this.rtv_approval_code_search = '';
        this.putaway_filter = null;
      },

      // filter Dialog PopUP 
      filterListOfButtons(ev) {
        this.filterPopup = true;
        this.search_tag = '';
      },

      // Update Dialog for Pending Confirmation Tab
      updatedialog() {
        const vendors = this.selected.map(item => item.vendor)
        const vendorList = Array.from(new Set(vendors));
        if (vendorList.length > 1) {
          this.showAlert("warning", "Please select the items with same vendor!");
          this.selected = []
          return;
        }

        const brands = this.selected.map(item => item.brand)
        const brondList = Array.from(new Set(brands));
        if (brondList.length > 1) {
          this.showAlert("warning", "Please select the items with same Brand!");
          this.selected = []
          return;
        }

        const statuss = this.selected.map(item => item.confirmation_status)
        const NumberOfStatus = Array.from(new Set(statuss));
        if (NumberOfStatus.length > 1) {
          this.showAlert("warning", "Please select the items either Confirmed or Not Confirmed!");
          this.selected = []
          return;
        }
        this.UpdatePopup = true;
        this.currentUdateTab = 'Update'
        this.tab_index = 1;
        if (this.selected[0].confirmation_status == 'Confirmed') {
          this.returnMethod = this.selected[0].return_method
          this.returnDocType = this.selected[0].return_document_type;
        }
      },

      // submit on update dialog in Pending-Confirmation
      updatePendingConfirmationSubmit() {
        this.number++;
        this.rtv_id = this.selected.map(vendor_returns => vendor_returns.id)
        const vendor_return = {
          "ids": this.rtv_id,
          "return_date": this.formatted_filter_date(this.rtv_return_date),
          "return_method": this.returnMethod,
          "return_document_type": this.returnDocType,
        }
        this.$httpSecured.post("/api/v2/warehouse/vendor_return/pending_confirmation/update_confirmation", {
          "vendor_return": vendor_return
        })
          .then(response => {
            if (response.data) {
              this.message = response.data.message
              this.UpdatePopup = false;
              this.okapproveconfirmpopup = true;
              this.rtv_return_date = '';
              this.returnMethod = '';
              this.returnDocType = '';
              this.number = 0;
              this.showAlert("success", "Successfully updated");
            } else {
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            // this.showAlert("error", "Something went wrong from Network" + error);
            this.$toast.error(error.response.data.error)
            this.loading = false;
            this.number = 0;
          });
      },

      // clear all fields when clicked cancel in pending-confirmation
      updatePendingConfirmationCancel() {
        this.rtv_return_date = '';
        this.returnMethod = null;
        this.returnDocType = null;
        this.UpdatePopup = false;
      },

      afterClickOkLoadData() {
        this.okapproveconfirmpopup = false;
        this.loadData(this.active_tab);
      },

      itemDetailpopup(item) {
        if (this.isPendingConfirmationTab) {
          this.dataDetailPendingConfirmationPopup = true;
          this.tag_number = item.tag_number;
          let str = String(this.tag_number);
          this.tag_number = str;
          this.item_id = item.id;
          this.item_details = item;
        } else if (this.active_tab == 'Dispatch') {
          this.dataDetailDispatchPopup = true;
          this.tag_number = item.tag_number;
          let str = String(this.tag_number);
          this.tag_number = str;
          this.item_id = item.id;
          this.item_details = item;
        }
      },

      handlePageChange(value) {
        this.page = value;
        if (this.active_tab === 'Pending Confirmation') {
          this.fetchPendingConfirmation();
        } else if (this.active_tab === 'Pending ORRD') {
          this.fetchPendingOrrd();
        } else if(this.active_tab == 'Pending For Approval'){
          this.fetchPendingForApproval();
        } else {
          this.fetchDispatch();
        }
      },

      handlePageSizeChange(size) {
        this.pageSize = size;
        this.page = 1
        if (this.active_tab === 'Pending Confirmation') {
          this.fetchPendingConfirmation();
        } else if (this.active_tab === 'Pending ORRD') {
          this.fetchPendingOrrd();
        }else if(this.active_tab == 'Pending For Approval'){
          this.fetchPendingForApproval();
        } else {
          this.fetchDispatch();
        }
      },
      update_current_Tab(tab) {
        this.currentUdateTab = tab;
      },
      deleteEvent(item) {
        const index = this.selected.indexOf(item);
        this.selected.splice(index, 1);
      },
      redirect_to_upload(){
      this.$store.commit("setLotIds", {
            lotIds: 'rtv',
            action:this.active_tab,
            inventoryId: 'RTV'
          });
      this.$store.commit("config/ADD_HEADER", this.headerText);
      this.$router.push({ name: 'LotFileuploadComm' });
      },
      openPopup() {
        this.downloadDialog = true;
      },
      downloadSelected() {
        const type = this.selected.length === 0 ? 'submit' : 'selected';
        this.$refs.downloadPopup.downloadConfirmation(type);
      },

      handleShowAlert(alertData) {
        this.showAlert(alertData.type, alertData.message);
      },
      handleSaveDate(dateType , dateState, selectDateState){
        this[dateState] = this.formatted_filter_date(this[selectDateState])
        this[dateType] = false
      },
      handleSuccess(msg) {
        this.okapproveconfirmpopup = true;
        this.message = msg
      }
    },
  }
</script>
<style scoped>
  .v-dialog:has(.filter-repair) {
    justify-content: right;
    align-items: baseline;
    top: 13rem;
  }

  .link-color {
    color: #0357D0;
    font-size: 14px;
    font-weight: 600;
  }

  .bg-color {
    background: #0357D0;
    color: #ffffff;
  }
  .item-selected {
    margin-top: 29px;
    position: absolute;
    left: 35%;
  }
  @media (max-height: 1104px) {
    .PaddingItemPerPage{
      padding: 8px !important;
    }
  }
  @media (min-height: 1126px) {
    .PaddingItemPerPage{
      padding: 24px !important;
    }
  }
  .v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 338px) !important;
  }
  .custom-control_outlined button {
      min-height: 52px;
      border-width: 1px;
      border-radius: 4px;
      border-color: rgba(0,0,0,.42);
      border-style: solid;
  }
  .custom-control_outlined button:focus {
    outline: none;
  }
  .custom-control_outlined .v-expansion-panel:before {
    box-shadow: none;
  }
  .filter_ui{
    margin-left: 32px !important;
 }
</style>
